export default {
  name: "backButton",
  props: {
    url: {
      type: String,
      default: ''
    },
    clearStyle: {
      type: Boolean,
      default: false
    },
    roundButton: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goBack() {
      if (this.url)
        this.$router.push(`/${this.url}`);
      else
        this.$router.go(-1);
    }
  }
}
